import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard/Index.vue'

//users
import Users from '../views/Users/Index.vue';
import NewUser from '../views/Users/Add.vue';
import ShowUser from '../views/Users/Show.vue';
import EditUser from '../views/Users/Edit.vue';
import UsersRole from '../views/Users/Roles/Assign.vue';
import UsersPermission from '../views/Users/Permissions/Assign.vue';

//permissions 
import Permissions from '../views/Permissions/Index.vue';
import NewPermission from '../views/Permissions/Add.vue';
import PermissionModal from '../views/Permissions/Modal.vue';
import EditPermission from '../views/Permissions/Edit.vue';
import ShowPermission from '../views/Permissions/Show.vue';

//roles
import Roles from '../views/Roles/Index.vue';
import NewRole from '../views/Roles/Add.vue';
import RoleModal from '../views/Roles/Modal.vue';
import EditRole from '../views/Roles/Edit.vue';
import ShowRole from '../views/Roles/Show.vue';
import RolesPermission from '../views/Roles/Permissions/Assign.vue'

//user auth + management
import Login from '../views/Auth/Login.vue';
import Register from '../views/Auth/Register.vue';
import ForgotPassword from '../views/Auth/Forgot.vue';
import Reset from '../views/Auth/Reset.vue';
import VerifyEmail from '../views/Auth/Verify.vue';
import Account from '../views/User/Index.vue';
import ShowAccount from '../views/User/Show.vue';
import EditAccount from '../views/User/Edit.vue';

//Error Pages
import ErrorIndex from '../views/Error/Index.vue';
import Error403 from '../views/Error/403.vue';

Vue.use(VueRouter)

const roles = ['Admin'];
const routes = [{
    path: '/',
    name: 'home',
    component: Dashboard,
    meta: {
      auth: true
    }
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      auth: {
        roles: roles,
        redirect: {
          name: 'admin'
        },
        forbiddenRedirect: '/admin/403'
      }
    },
    children: [{
        path: 'role/:id',
        name: 'assign-users-role',
        component: UsersRole,
      },
      {
        path: 'permission/:id',
        name: 'assign-users-permission',
        component: UsersPermission,
      },
      // {
      //   path: 'users/new',
      //   name: 'users-create',
      //   component: NewUser,
      // },
      // {
      //   path: 'users/:id',
      //   name: 'users-show',
      //   component: ShowUser,

      //   children: [{
      //     path: ':id/edit',
      //     name: 'users-edit',
      //     component: EditUser,
      //   }]
      // }
    ]
  },
  {
    path: '/users/new',
    name: 'users-create',
    component: NewUser,
    meta: {
      auth: true
    }

  },
  {
    path: '/users/:id',
    name: 'users-show',
    component: ShowUser,
    meta: {
      auth: true
    }
  },
  {
    path: '/users/:id/edit',
    name: 'users-edit',
    component: EditUser,
    meta: {
      auth: true
    }
  },
  {
    path: '/permissions',
    name: 'permissions',
    component: Permissions,
    meta: {
      auth: {
        roles: roles,
        redirect: {
          name: 'admin'
        },
        forbiddenRedirect: '/admin/403'
      }
    },
    children: [{
      path: 'new',
      name: 'permissions-create',
      component: NewPermission,
    }, {
      path: ':id',
      component: PermissionModal,
      children: [{
        path: '/',
        name: 'permissions-show',
        component: ShowPermission
      }, {
        path: 'edit',
        name: 'permissions-edit',
        component: EditPermission
      }]
    }]
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    children: [{
      path: '/',
      name: 'account-show',
      component: ShowAccount,
    }, {
      path: 'edit',
      name: 'account-edit',
      component: EditAccount
    }]
  },
  {
    path: '/roles',
    name: 'roles',
    component: Roles,
    meta: {
      auth: {
        roles: roles,
        redirect: {
          name: 'admin'
        },
        forbiddenRedirect: '/admin/403'
      }
    },
    children: [{
        path: 'permission/:id',
        name: 'assign-roles-permission',
        component: RolesPermission,
      },
      {
        path: 'new',
        name: 'roles-create',
        component: NewRole,
      },
      {
        path: ':id',
        component: RoleModal,
        children: [{
          path: '/',
          name: 'roles-show',
          component: ShowRole
        }, {
          path: 'edit',
          name: 'roles-edit',
          component: EditRole
        }]
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: Reset,
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: VerifyEmail
  },

  //Error Pages

  {
    path: '/admin',
    name: 'error-page',
    component: ErrorIndex,

    children: [{
      path: '403',
      name: 'error-403',
      component: Error403
    }]
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router